import { inject,Injectable } from '@angular/core';

import * as Sentry from '@sentry/angular';

import { AppEventsEvent, PageViewEvent, SurveyEvent } from './events';
import { BaseGetFeedbackEvent } from './events/base-event.interface';
import { UsabillaService } from './usabilla.service';

@Injectable({
  providedIn: 'root',
})
export class GetFeedbackService {
  private readonly _usabillaService = inject(UsabillaService);
  private readonly _eventHandlers: readonly BaseGetFeedbackEvent[] = [
    inject(PageViewEvent),
    inject(SurveyEvent),
    inject(AppEventsEvent),
  ];

  public async init(): Promise<void> {
    try {
      if (!this._usabillaService.isEnabled()) {
        Sentry.captureException(
          new Error('Usabilla script loaded but service is not enabled'),
          { tags: { component: 'GetFeedbackService' } },
        );
        return;
      }

      this._eventHandlers.forEach((handler) => handler.init());
    } catch (error) {
      Sentry.captureException(error, {
        tags: { component: 'GetFeedbackService' },
      });
    }
  }
}
